'use strict';

module.exports = 'Do MMM YYYY';
